import { AnyAction } from 'redux';
import { SUCCESS } from 'redux-and-the-rest';

import { userActions } from './userReducer';
import configureRequestAuthToken from './utils/configureRequestAuthToken';

export interface AuthenticationState {
  authenticationToken?: string;
}

const INITIAL_STATE: AuthenticationState = {
};

export default (state: AuthenticationState = INITIAL_STATE, action: AnyAction): AuthenticationState => {
  if (action.type === userActions.createItem && action.status === SUCCESS) {
    const { authenticationToken } = action.item.values;

    // On the creation of a user session, we need to reconfigure the RATR auth token
    configureRequestAuthToken(authenticationToken);

    return {
      authenticationToken,
    };
  }

  if ([userActions.destroyItem, userActions.clearItem].includes(action.type)) {
    // When clearing a user in order to logout, we need to reset the RATR auth token configuration
    configureRequestAuthToken();

    return INITIAL_STATE;
  }

  return state;
};
